import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Grid, TextField } from "@mui/material";
import { alertService, GenericFileCrop, setBackdrop } from "common-frontend-components";
import { galleriesStore } from "../../../../stores/galleries/galleriesStore";
import { callCreateGalleryAsync } from "../../../../apis/galleries";
import { createImageProcessingAwaiter, PhotoUploader, } from "../../posts/Photos/PhotoUploader";
import { CategorySelector } from "../../categories/SelectCategory";
import { callCreateGalleryCategoryAssociationAsync } from "../../../../apis/galleryCategoryAssociations";
import { galleryCategoryAssociationsStore } from "../../../../stores/galleries/galleryCategoryAssociationsStore";
import { textColor } from "../../../../assets/styles/colors";
import { postCardStyle, textFieldStyle } from "../../../../assets/styles/styles";
import { OrderPhotos } from "../../posts/Photos/OrderPhotos";
import { callGetGalleryPhotoByKeyAsync, callUploadGalleryPhotoAsync } from "../../../../apis/galleryPhotos";
import { galleryPhotosStore } from "../../../../stores/galleries/galleryPhotosStore";
import { callGetGalleryIconByKeyAsync, callUploadGalleryIconAsync } from "../../../../apis/galleryIcons";
import { galleryIconsStore } from "../../../../stores/galleries/galleryIconsStore";
import { IndexInput } from "../../../custom/inputs/IndexInput";
export const handleOnDropWhenFormingNewGallery = (files) => {
    galleriesStore.setNewGallery({ ...galleriesStore.getNewGallery(), files });
};
const createGallery = async ({ name, description, index, }) => {
    const gallery = await callCreateGalleryAsync({
        name,
        description,
        index,
    });
    galleriesStore.setGalleries([gallery, ...galleriesStore.getGalleries()]);
    return gallery;
};
const createGalleryCategoryAssociations = async ({ categories }, galleryId) => {
    const galleryCategoryAssociations = [];
    for (const i of categories) {
        try {
            galleryCategoryAssociations.push(await callCreateGalleryCategoryAssociationAsync({ categoryId: i.id, galleryId }));
        }
        catch (e) {
            alertService.error(e);
        }
        finally {
            galleryCategoryAssociationsStore.setGalleryCategoryAssociations([...galleryCategoryAssociations, ...galleryCategoryAssociationsStore.getGalleryCategoryAssociations()]);
        }
    }
};
export const createGalleryImages = async (items, galleryId) => {
    const photos = [];
    for (const i of items) {
        console.log('starting upload', { GalleryImageItem: i });
        const res = await callUploadGalleryPhotoAsync(i.file, {
            contentType: i.file.type,
            galleryId,
            index: i.index,
        });
        console.log('upload complete!', { res });
        const waiter = createImageProcessingAwaiter(() => callGetGalleryPhotoByKeyAsync(res.key));
        const photo = await waiter();
        if (photo !== null) {
            photos.push(photo);
        }
    }
    if (photos.length > 0) {
        const photoLists = [...galleryPhotosStore.getPhotos()];
        for (let i = 0; i < photoLists.length; i++) {
            for (const photo of photoLists[i]) {
                if (photo.galleryId === galleryId) {
                    photoLists[i] = [...photos, ...photoLists[i]];
                    galleryPhotosStore.setPhotos(photoLists);
                    return;
                }
                break; // galleryId is the same for each member in the list
            }
        }
        galleryPhotosStore.setPhotos([photos, ...photoLists]);
    }
};
export const createGalleryIcons = async (items, galleryId) => {
    const photos = [];
    for (const i of items) {
        console.log('starting upload', { GalleryImageItem: i });
        const res = await callUploadGalleryIconAsync(i.file, {
            contentType: i.file.type,
            galleryId,
            index: i.index,
        });
        console.log('upload complete!', { res });
        const waiter = createImageProcessingAwaiter(() => callGetGalleryIconByKeyAsync(res.key));
        const photo = await waiter();
        if (photo !== null) {
            photos.push(photo);
        }
    }
    if (photos.length > 0) {
        const photoLists = [...galleryIconsStore.getIcons()];
        for (let i = 0; i < photoLists.length; i++) {
            for (const photo of photoLists[i]) {
                if (photo.galleryId === galleryId) {
                    photoLists[i] = [...photos, ...photoLists[i]];
                    galleryIconsStore.setIcons(photoLists);
                    return;
                }
                break; // galleryId is the same for each member in the list
            }
        }
        galleryIconsStore.setIcons([photos, ...photoLists]);
    }
};
export const onCreateGallery = async () => {
    const newGallery = galleriesStore.getNewGallery();
    setBackdrop(true);
    try {
        const gallery = await createGallery(newGallery);
        await createGalleryCategoryAssociations(newGallery, gallery.id);
        if (newGallery.preview)
            await createGalleryIcons([
                { file: new File([newGallery.preview?.file], "preview.png", { type: "image/png", lastModified: Date.now() }), index: 0 },
            ], gallery.id);
        if (newGallery.files.length > 0)
            await createGalleryImages(newGallery.files.map((file, index) => ({ file, index: index + 1 })), gallery.id);
        galleriesStore.clearNewGallery();
    }
    catch (e) {
        alertService.error(e);
    }
    finally {
        setBackdrop(false);
    }
};
const SelectCategory = () => _jsx(CategorySelector, { value: galleriesStore.useNewGalleryCategories(), onChange: galleriesStore.onNewGalleryCategoryChange }, void 0);
export const PreviewImg = ({ preview, setPreview }) => _jsx(GenericFileCrop, { render: ({ selectFile }) => _jsx(Box, { onClick: selectFile, sx: { width: 285, height: 175 }, children: preview ? _jsx(Box, { component: 'img', sx: { width: '100%', height: '100%', cursor: 'pointer' }, src: preview?.imageSrc || preview?.url || "", alt: "click to change preview image" }, void 0) : _jsx(Button, { sx: { width: '100%', height: '100%' }, variant: 'contained', children: "click to add a preview image" }, void 0) }, void 0), aspect: 285 / 175, onImage: setPreview, width: 285, height: 175 }, void 0);
export const CreateGallery = () => {
    const name = galleriesStore.useNewGalleryName();
    const description = galleriesStore.useNewGalleryDescription();
    const preview = galleriesStore.useNewGalleryPreviewImg();
    const index = galleriesStore.useNewGalleryIndex();
    return (_jsx(Box, { sx: { minWidth: 275 }, children: _jsxs(Card, { variant: "outlined", elevation: 3, sx: postCardStyle, children: [_jsxs(CardContent, { children: [_jsx(Typography, { sx: { fontSize: 16, paddingBottom: 2, color: textColor }, color: "text.secondary", gutterBottom: true, children: "New Gallery" }, void 0), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, children: _jsx(TextField, { sx: textFieldStyle, label: "title", variant: "outlined", value: name, onChange: galleriesStore.handleNewGalleryNameChange }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { sx: textFieldStyle, label: "description", variant: "outlined", value: description || "", onChange: galleriesStore.handleNewGalleryDescriptionChange, fullWidth: true, multiline: true }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(PreviewImg, { preview: preview, setPreview: galleriesStore.setNewGalleryPreviewImg }, void 0) }, void 0), _jsx(OrderPhotos, { useItems: galleriesStore.useNewGalleryFiles, setItems: galleriesStore.setNewGalleryFiles, parent: ({ children }) => _jsx(Grid, { item: true, xs: 12, children: children }, void 0) }, void 0), _jsx(Grid, { item: true, children: _jsx(PhotoUploader, { onDrop: handleOnDropWhenFormingNewGallery, usePreviewFiles: galleriesStore.useNewGalleryFiles, setPreviewFiles: galleriesStore.setNewGalleryFiles }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(SelectCategory, {}, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(IndexInput, { index: index, onIndexChange: galleriesStore.setNewGalleryIndex }, void 0) }, void 0)] }, void 0)] }, void 0), _jsx(CardActions, { children: _jsx("div", { style: { paddingLeft: 4, paddingRight: 4 }, children: _jsx(Button, { size: "small", onClick: onCreateGallery, children: "Create Gallery" }, void 0) }, void 0) }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=CreateGallery.js.map